import { TRACKING_BEHAVIOR, useExperimentation } from '~/client/hooks/useExperimentation'
import { PRODUCT_COLLECTIONS_VARIATIONS } from 'shared/experiments/ProductCollections/constants'

export const useShowProductCollections = (): boolean => {
  const isExperimentActive = useExperimentation()

  return (
    isExperimentActive(PRODUCT_COLLECTIONS_VARIATIONS.Enabled1, TRACKING_BEHAVIOR.Suppress) ||
    isExperimentActive(PRODUCT_COLLECTIONS_VARIATIONS.Enabled2, TRACKING_BEHAVIOR.Suppress)
  )
}
